export const InvoicePaymentStatus = {
    Paid: 'paid',
    Unpaid: 'unpaid',
} as const;

export type InvoicePaymentStatus = typeof InvoicePaymentStatus[keyof typeof InvoicePaymentStatus];

export const InvoicePaymentFilter = {
    ...InvoicePaymentStatus,
    All: 'all',
    Partial: 'partial',
} as const;

export type InvoicePaymentFilter = typeof InvoicePaymentFilter[keyof typeof InvoicePaymentFilter];

// Legacy update command; cancellation is not a payment status.
export const InvoicePaymentAction = { ...InvoicePaymentStatus, Cancelled: 'cancelled' } as const;
export type InvoicePaymentAction = typeof InvoicePaymentAction[keyof typeof InvoicePaymentAction];

export function toPaidFlag(status?: string | null): boolean | null {
    switch (status) {
        case InvoicePaymentStatus.Paid: return true;
        case InvoicePaymentStatus.Unpaid: return false;
        default: return null;
    }
}
